import { date, object } from 'yup';
import { EndDate } from '../UserDataManagement';
const RequiredMessage = 'Entitlement year end date is required to continue with your account set up.';
export const introHolidayYearFormSchemaFunc = () => object({
    [EndDate]: date().nullable().required(RequiredMessage).typeError(RequiredMessage),
});
